import { render, staticRenderFns } from "./newForm.vue?vue&type=template&id=71e33d36&"
import script from "./newForm.ts?vue&type=script&lang=ts&"
export * from "./newForm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports